const SET_CERTIFICATES_DATA = 'SET_CERTIFICATES_DATA';
const SAVE_CERTIFICATES = 'SAVE_CERTIFICATES';
const UPDATE_CERTIFICATES_PAGINATION = 'UPDATE_CERTIFICATES_PAGINATION';
const DELETE_CERTIFICATE = 'DELETE_CERTIFICATE';

const setCertificatesData = data => {
    return {
        type: SET_CERTIFICATES_DATA,
        data
    };
}

const saveCertificates = data => {
    return {
        type: SAVE_CERTIFICATES,
        data
    };
}

const updateCertificatesPagination = data => {
    return {
        type: UPDATE_CERTIFICATES_PAGINATION,
        data
    }
}

const deleteCertificate = (taxId, query) => {
    return {
        type: DELETE_CERTIFICATE,
        taxId,
        query
    }
}

export default {
    types: {
        SET_CERTIFICATES_DATA,
        SAVE_CERTIFICATES,
        UPDATE_CERTIFICATES_PAGINATION,
        DELETE_CERTIFICATE
    },
    
    actions: {
        setCertificatesData,
        saveCertificates,
        updateCertificatesPagination,
        deleteCertificate

    }
}